import { resume, resumeAnchor } from "./resume";
import notes from "../assets/icons/dock/notes.png";
import chrome from "../assets/icons/dock/chrome.png";
import clock from "../assets/icons/dock/clock.png";
import finderApp from "../assets/icons/dock/finder.png";
import ghostty from "../assets/icons/dock/ghostty.png";
import orbstack from "../assets/icons/dock/orbstack.png";
import spotify from "../assets/icons/dock/spotify.png";
import terminal from "../assets/icons/dock/terminal.png";
import zed from "../assets/icons/dock/zed.png";
import folder from "../assets/icons/finder/folder.png";
import webLocation from "../assets/icons/finder/web-location.png";
import pdf from "../assets/icons/finder/pdf.png";
import plainText from "../assets/icons/finder/text.png";
import zip from "../assets/icons/finder/zip.png";
import screenshot from "../assets/icons/finder/screenshot.png";

// What Finder shows: a small file system built from the resume, so every file leads somewhere
// real. `open` describes what double-clicking does:
//   { resume: anchor }  open Notes at that part of the resume (no anchor: the top)
//   { url }             open a link
//   { app: name }       launch an app from the Dock
//   { folder: id }      go into a folder
//   { binned: true }    nothing: it's in the Bin

const note = (name, anchor, kind = "Note") => ({ name, icon: notes, kind, open: { resume: anchor } });
const link = (name, url) => ({ name, icon: webLocation, kind: "Web Location", open: { url } });
const dir = (name, id) => ({ name, icon: folder, kind: "Folder", open: { folder: id } });
const app = (name, icon) => ({ name, icon, kind: "Application", open: { app: name } });
const binned = (name, icon, kind) => ({ name, icon, kind, open: { binned: true } });

const contact = (label) => resume.contacts.find((c) => c.label === label);

export const FOLDERS = {
  recents: {
    title: "Recents",
    items: [
      note("Resume"),
      note(resume.experience[0].company.split(",")[0], resumeAnchor(resume.experience[0].company)),
      link(contact("Website").text.replace(/^www\./, ""), contact("Website").href),
    ],
  },
  applications: {
    title: "Applications",
    items: [
      app("Clock", clock),
      app("Finder", finderApp),
      app("Ghostty", ghostty),
      app("Google Chrome", chrome),
      app("Notes", notes),
      app("OrbStack", orbstack),
      app("Spotify", spotify),
      app("Terminal", terminal),
      app("Zed", zed),
    ],
  },
  desktop: { title: "Desktop", items: [note("Resume")] },
  documents: {
    title: "Documents",
    items: [dir("Work Experience", "work"), dir("Projects", "projects"), dir("Certifications", "certifications"), note("Resume")],
  },
  downloads: {
    title: "Downloads",
    items: [
      link(contact("Website").text.replace(/^www\./, ""), contact("Website").href),
      link("LinkedIn", contact("LinkedIn").href),
      link("Email Sylvester", contact("Email").href),
    ],
  },
  work: {
    title: "Work Experience",
    parent: "documents",
    items: resume.experience.map((job) => note(job.company.split(",")[0], resumeAnchor(job.company))),
  },
  projects: {
    title: "Projects",
    parent: "documents",
    items: resume.projects.map((p) => note(p.name.split(" — ")[0], resumeAnchor(p.name))),
  },
  certifications: {
    title: "Certifications",
    parent: "documents",
    items: resume.certifications.map((c) => note(c.name, resumeAnchor(c.name))),
  },
  // The Bin, from the Dock: a few made-up things thrown away, until someone empties it.
  bin: {
    title: "Bin",
    bin: true,
    items: [
      binned("node_modules", folder, "Folder"),
      binned("portfolio-v1.zip", zip, "ZIP archive"),
      binned("resume-draft-2.pdf", pdf, "PDF Document"),
      binned("Screenshot 2026-10-14 at 09.41.07", screenshot, "PNG image"),
      binned("todo-old.txt", plainText, "Plain Text Document"),
    ],
  },
};

export const SIDEBAR = [
  { title: "Favorites", items: ["recents", "applications", "desktop", "documents", "downloads"] },
];
